import { gql } from '@apollo/client';

// Exit Strategy Templates
export const CREATE_EXIT_STRATEGY_TEMPLATE = gql`
  mutation CreateExitStrategyTemplate($input: ExitStrategyTemplateInput!) {
    createExitStrategyTemplate(input: $input) {
      success
      error
      template {
        id
        name
        createdAt
        updatedAt
        targetMultiple
        baseSource
        exitLevelsCount
        exitLevelsSpread
        takeInitialsEnabled
        takeInitialsMultiple
        hodlEnabled
        hodlPercentage
        advancedDistributionEnabled
        distributionCurve
        distributionFocus
        distributionIntensity
        positionsCount
      }
    }
  }
`;

export const UPDATE_EXIT_STRATEGY_TEMPLATE = gql`
  mutation UpdateExitStrategyTemplate($id: ID!, $input: ExitStrategyTemplateInput!) {
    updateExitStrategyTemplate(id: $id, input: $input) {
      success
      error
      template {
        id
        name
        createdAt
        updatedAt
        targetMultiple
        baseSource
        exitLevelsCount
        exitLevelsSpread
        takeInitialsEnabled
        takeInitialsMultiple
        hodlEnabled
        hodlPercentage
        advancedDistributionEnabled
        distributionCurve
        distributionFocus
        distributionIntensity
        positionsCount
      }
    }
  }
`;

export const DELETE_EXIT_STRATEGY_TEMPLATE = gql`
  mutation DeleteExitStrategyTemplate($id: ID!) {
    deleteExitStrategyTemplate(id: $id) {
      success
      error
    }
  }
`;

// Invalidation Strategy Templates
export const CREATE_INVALIDATION_STRATEGY_TEMPLATE = gql`
  mutation CreateInvalidationStrategyTemplate($input: InvalidationStrategyTemplateInput!) {
    createInvalidationStrategyTemplate(input: $input) {
      success
      error
      template {
        id
        name
        createdAt
        updatedAt
        priceBasedEnabled
        priceDropPercentage
        timeBasedEnabled
        timeDurationDays
        positionsCount
      }
    }
  }
`;

export const UPDATE_INVALIDATION_STRATEGY_TEMPLATE = gql`
  mutation UpdateInvalidationStrategyTemplate($id: ID!, $input: InvalidationStrategyTemplateInput!) {
    updateInvalidationStrategyTemplate(id: $id, input: $input) {
      success
      error
      template {
        id
        name
        createdAt
        updatedAt
        priceBasedEnabled
        priceDropPercentage
        timeBasedEnabled
        timeDurationDays
        positionsCount
      }
    }
  }
`;

export const DELETE_INVALIDATION_STRATEGY_TEMPLATE = gql`
  mutation DeleteInvalidationStrategyTemplate($id: ID!) {
    deleteInvalidationStrategyTemplate(id: $id) {
      success
      error
    }
  }
`;

// Apply/Remove strategies to positions
export const APPLY_INVALIDATION_STRATEGY = gql`
  mutation ApplyInvalidationStrategy($templateId: ID!, $portfolioId: ID!, $tokenId: ID!) {
    applyInvalidationStrategy(templateId: $templateId, portfolioId: $portfolioId, tokenId: $tokenId) {
      success
      error
      level {
        id
        portfolioId
        tokenId
        triggerPrice
        timeDurationDays
        templateId
        templateName
        isModified
        isPriceTriggered
        isTimeTriggered
      }
    }
  }
`;

export const REMOVE_INVALIDATION_STRATEGY = gql`
  mutation RemoveInvalidationStrategy($portfolioId: ID!, $tokenId: ID!) {
    removeInvalidationStrategy(portfolioId: $portfolioId, tokenId: $tokenId) {
      success
      error
    }
  }
`;

export const UPDATE_INVALIDATION_LEVEL = gql`
  mutation UpdateInvalidationLevel($portfolioId: ID!, $tokenId: ID!, $input: UpdateInvalidationLevelInput!) {
    updateInvalidationLevel(portfolioId: $portfolioId, tokenId: $tokenId, input: $input) {
      success
      error
      level {
        id
        portfolioId
        tokenId
        triggerPrice
        timeDurationDays
        templateId
        templateName
        isModified
        isPriceTriggered
        isTimeTriggered
      }
    }
  }
`;
